import { makeAutoObservable } from "mobx";

const DEFAULT_PAGE_SIZE = 5;

class DashboardConsolidatedMetricOverviewStore {
  rows = [];
  total = 0;

  // search lives on the shared overview store so both modes search the same
  // disclosures with one input. page/pageSize are per-mode so paginating in
  // one mode doesn't strand the user mid-page after toggling.
  page = 1;
  pageSize = DEFAULT_PAGE_SIZE;

  loading = false;
  hasLoadedOnce = false;

  constructor() {
    makeAutoObservable(this);
  }

  setResult = ({ rows, total, page, pageSize }) => {
    this.rows = rows ?? [];
    this.total = Number(total ?? 0);
    this.page = Number(page ?? this.page);
    this.pageSize = Number(pageSize ?? this.pageSize);
    this.hasLoadedOnce = true;
  };

  setLoading = (value) => {
    this.loading = Boolean(value);
  };

  setPageSize = (value) => {
    const n = Number(value);
    if (!Number.isFinite(n) || n < 1) return;
    this.pageSize = n;
    this.page = 1;
  };

  setPage = (value) => {
    const n = Number(value);
    if (!Number.isFinite(n) || n < 1) return;
    this.page = n;
  };

  reset = () => {
    this.rows = [];
    this.total = 0;
    this.page = 1;
    this.pageSize = DEFAULT_PAGE_SIZE;
    this.loading = false;
    this.hasLoadedOnce = false;
  };
}

export const dashboardConsolidatedMetricOverviewStore =
  new DashboardConsolidatedMetricOverviewStore();
